import styled from 'styled-components'

export const GallerySliderWrapper = styled.div`
    width: 100%;
    height: 100%;

    // custom swiper elements
    .swiper-btn-prev,
    .swiper-btn-next {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 11px;
        bottom: 50%;
        z-index: 100;
        background-color: rgba(255, 255, 255, 0.7);
        opacity: 0;
        border-radius: 50px;
        pointer-events: none;
        cursor: pointer;
        transform: translateY(50%);
        transition: all 0.2s ease-in-out;
        line-height: 29px;
        text-align: center;

        &:focus-visible {
            opacity: 1;
            outline: 2px solid ${({ theme }) => theme.colors.primary_500};
        }
    }
    .swiper-btn-next {
        left: auto;
        right: 11px;
    }

    // generic classes from swiper plugin
    .swiper {
        height: 100%;
        cursor: zoom-in;

        &:hover {
            .swiper-btn-prev,
            .swiper-btn-next {
                opacity: 1;
                pointer-events: all;
            }
        }
    }
    .swiper-button-disabled {
        opacity: 0 !important;
        pointer-events: none !important;
    }
    .swiper-pagination-bullets {
        cursor: pointer;
    }
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        margin: 0 2px !important;
        background-color: ${({ theme }) => theme.colors.grayscale_800};
        border: 1px solid rgba(255, 255, 255, 0.8);
        transform: scale(1);
        opacity: 1;
        transition: all 0.2s ease-in-out;
    }
    .swiper-pagination-bullet-active {
        width: 14px;
        border-width: 2px;
        border-radius: 10px;
        border-color: rgba(255, 255, 255, 1);
    }
`

export const MobileTrigger = styled.button`
    position: relative;
    width: 100%;
    height: 100%;
    cursor: zoom-in;

    img {
        object-fit: cover;
    }
`

export const MobileTriggerIcon = styled.div`
    position: absolute;
    right: 3px;
    top: 3px;
    z-index: 100;
    width: 18px;
    height: 18px;
    border-radius: 50px;
    background-color: rgba(255, 255, 255, 0.7);
    text-align: center;
    line-height: 16px;
`
